(function () {
  const REFRESH_CLASS = 'qeviq-pdp-purchase-refresh';
  const REFRESH_MS = 340;

  function triggerPurchaseRefresh(container) {
    if (!container) return;
    container.classList.remove(REFRESH_CLASS);
    void container.offsetWidth;
    container.classList.add(REFRESH_CLASS);
    window.setTimeout(() => container.classList.remove(REFRESH_CLASS), REFRESH_MS);
  }

  document.addEventListener(
    'click',
    (event) => {
      const card = event.target.closest('.product-info--qeviq [data-qbs-card]');
      if (!card || event.target.closest('[data-qbs-gallery-nav], [data-qbs-gallery-dot]')) return;

      const productInfo = card.closest('product-info.product-info--qeviq');
      if (!productInfo) return;

      triggerPurchaseRefresh(productInfo);
    },
    true
  );

  if (!document.querySelector('.product-info--qeviq')) return;

  const MIN_DELTA = 8;
  const GALLERY_SWIPE_SELECTOR =
    '.product-info--qeviq .product__media-list.slider--mobile, .product-info--qeviq .thumbnail-list.slider--mobile, .product-info--qeviq .qeviq-pdp-media-mobile';

  function isModalOpen() {
    return (
      document.body.classList.contains('qeviq-media-modal-open') ||
      document.body.classList.contains('overflow-hidden') ||
      document.querySelector('product-modal.product-media-modal--qeviq[open]')
    );
  }

  function canScrollHorizontally(element, direction) {
    let node = element instanceof Element ? element : null;

    while (node && node !== document.body) {
      const style = window.getComputedStyle(node);
      const overflowX = style.overflowX;

      if (
        (overflowX === 'auto' || overflowX === 'scroll' || overflowX === 'overlay') &&
        node.scrollWidth > node.clientWidth + 1
      ) {
        const maxScroll = node.scrollWidth - node.clientWidth;
        const scrollLeft = node.scrollLeft;

        if (direction > 0 && scrollLeft < maxScroll - 1) return true;
        if (direction < 0 && scrollLeft > 1) return true;
        if (direction === 0) return true;
      }

      node = node.parentElement;
    }

    return false;
  }

  let startX = 0;
  let startY = 0;
  let tracking = false;

  function resetTouchTracking() {
    tracking = false;
    startX = 0;
    startY = 0;
  }

  document.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length !== 1) {
        resetTouchTracking();
        return;
      }

      if (isModalOpen()) {
        resetTouchTracking();
        return;
      }

      const target = event.target instanceof Element ? event.target : null;
      if (!target?.closest(GALLERY_SWIPE_SELECTOR)) {
        resetTouchTracking();
        return;
      }

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!tracking || event.touches.length !== 1) return;
      if (isModalOpen()) {
        resetTouchTracking();
        return;
      }

      const dx = event.touches[0].clientX - startX;
      const dy = event.touches[0].clientY - startY;

      if (Math.abs(dx) < MIN_DELTA && Math.abs(dy) < MIN_DELTA) return;
      if (Math.abs(dy) > Math.abs(dx)) {
        resetTouchTracking();
        return;
      }

      const direction = dx < 0 ? 1 : -1;
      const target = event.target instanceof Element ? event.target : null;

      if (canScrollHorizontally(target, direction)) return;

      event.preventDefault();
    },
    { passive: false }
  );

  document.addEventListener('qeviq:gallery-modal-open', resetTouchTracking);
  document.addEventListener('qeviq:gallery-modal-closed', resetTouchTracking);
  document.addEventListener('modalClosed', resetTouchTracking);

  document.addEventListener('touchend', resetTouchTracking, { passive: true });
  document.addEventListener('touchcancel', resetTouchTracking, { passive: true });
})();
